import React from 'react';
import { formatDecimal } from 'utils/formatter';
import { connect } from 'react-redux';
import Slideshow from 'components/Slideshow';
import styles from './koinworksForm.css';
import KoinworksPersonalForm from './KoinworksPersonalForm';
import KoinworksBusinessForm from './KoinworksBusinessForm';
import KoinworksBankForm from './KoinworksBankForm';
import KoinworksEmergencyContactForm from './KoinworksEmergencyContactForm';
import KoinworksUploadForm from './KoinworksUploadForm';

class KoinWorksForm extends React.Component {
  state = {
    showSlideshow: false,
  };

  componentWillMount() {
    // load the image before mount, to avoid empty image container when user clicking bankTutorial
    this.bankTutorialSrc.forEach(bank => {
      const img = document.createElement('img');
      [, img.src] = bank;
    });
  }

  bankTutorialSrc = [
    [
      'Panduan Dokumen',
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/PanduanDokumen.png',
    ],
    [
      'BCA',
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/BCA.png',
    ],
    [
      'BNI',
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/BNI.png',
    ],
    [
      'Mandiri',
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/MAndiri.png',
    ],
  ];

  onLoanTypeChange(loanTypeString, e) {
    e.preventDefault();
    e.stopPropagation();
    this.props.changeField('loans_type', loanTypeString);
  }

  closeSlideshow() {
    this.setState({ showSlideshow: false });
  }

  openSlideshow() {
    this.setState({ showSlideshow: true });
  }

  render() {
    const {
      sendingRequest,
      logo,
      preApprovedAmount,
      interestRate,
      duration,
      lenderName,
      monthlyInstallment,
      onClickChange,
    } = this.props;
    const { loansType } = this.props;
    return (
      <div className={styles.wrapper}>
        <Slideshow
          showModal={this.state.showSlideshow}
          imageSrc={this.bankTutorialSrc.map(bank => bank[1])}
          imageAlt={this.bankTutorialSrc.map(bank => bank[0])}
          onCloseButtonClicked={this.closeSlideshow.bind(this)}
        />
        <div
          className={`col-md-12 ${styles['div-body']} spacer ${
            styles['no-padding']
          } ${styles['box-list']} ${styles['box-scroll']}`}
        >
          <div className={`col-md-12 ${styles['box-body']}`}>
            <table className="col-md-12 col-lg-12">
              <tr>
                <td className={`text-center`}>
                  <img src={logo} />
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Lender</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    {lenderName}
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Loan Amount</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    IDR {formatDecimal(preApprovedAmount)}
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Rate p.a.</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    {interestRate}%
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Tenure</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    {duration} months
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>
                    Monthly Instalment
                  </p>
                  <p className={`${styles['lender-sub-title']}`}>
                    IDR {formatDecimal(monthlyInstallment)}/month
                  </p>
                </td>
                <td className={`text-center`}>
                  <a onClick={onClickChange} className="btn btn-link">
                    Change
                  </a>
                </td>
              </tr>
            </table>
          </div>
          <div className="col-md-12 col-lg-12">
            <hr />
          </div>
          <KoinworksPersonalForm {...this.props} />
          <div className="col-md-12 col-lg-12">
            <hr />
          </div>
          <KoinworksBusinessForm {...this.props} />
          <div className="col-md-12 col-lg-12">
            <hr />
          </div>
          <KoinworksBankForm {...this.props} />
          <div className="col-md-12 col-lg-12">
            <hr />
          </div>
          <KoinworksEmergencyContactForm {...this.props} />
          <div className="col-md-12 col-lg-12">
            <hr />
          </div>
          <KoinworksUploadForm
            {...this.props}
            loansType={loansType}
            showSlideshow={this.state.showSlideshow}
            openSlideshow={this.openSlideshow.bind(this)}
            closeSlideshow={this.closeSlideshow.bind(this)}
          />
          <div className="col-md-12 col-lg-12">
            <hr />
          </div>
          <div className="col-md-12 col-lg-12">
            <p className={styles['float-right']}>
              <red>*</red>
              Required
            </p>
            <br />
            <hr />
            <button
              className={`btn ${styles['btn-upload-green']} `}
              disabled={sendingRequest}
              type="submit"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(KoinWorksForm);
